import Header from "../Header";
import Footer from "../Footer";
import Breadcrumbs from "../Breadcrumbs";
import BannerImg from "../assets/Images/hkasharmony.png";

import BottomLogoImg from "../assets/Images/bottom-logo.png";
import { useTranslation } from "react-i18next";
import TopImg from "../assets/Images/harmony4topimg.jpg";
import { Link } from "react-router-dom";
import "./ListofParticipatingInstitutionsPage.scss";

const ListofParticipatingInstitutionsPage = () => {
  const { t } = useTranslation();

  return (
    <>
      <Header />
      <div className="banner">
        <img src={BannerImg} alt="" />
        <div className="banner_title">
          <h1 className="banner-main-title">
            {t("list_of_partcipating_page_header")}
          </h1>
          <p className="banner-subtitle">
            {t("list_of_partcipating_page_header2")}
          </p>
        </div>
      </div>
      <Breadcrumbs>
        <Link>{t("breadcrumbs_list_of_partcipating_page_link1")}</Link>
        <span>{t("breadcrumbs_list_of_partcipating_page_span")}</span>
        <Link>{t("breadcrumbs_list_of_partcipating_page_link2")}</Link>
      </Breadcrumbs>
      <main className="participating-institutions-main-container">
        {/* <section className="participating-institutions-header-section">
          <h2 className="participating-institutions-section-title">
            {t("list_of_partcipating_page_h3")}
          </h2>
        </section> */}
        <section className="participating-institutions-content-section">
          <div className="participating-institutions-img-container">
            <img
              src={TopImg}
              alt=""
              className="participating-institutions-image"
            />
          </div>
        </section>
        {/* <div className="grid-text">
          <span>{t("list_of_partcipating_page_text1")}</span>
          <span>{t("list_of_partcipating_page_text2")}</span>
          <span>{t("list_of_partcipating_page_text3")}</span>
          <span>{t("list_of_partcipating_page_text4")}</span>
          <span>{t("list_of_partcipating_page_text5")}</span>
          <span>{t("list_of_partcipating_page_text6")}</span>
          <span>{t("list_of_partcipating_page_text7")}</span>
          <span>{t("list_of_partcipating_page_text8")}</span>
          <span>{t("list_of_partcipating_page_text9")}</span>
          <span>{t("list_of_partcipating_page_text10")}</span>
          <span>{t("list_of_partcipating_page_text11")}</span>
          <span>{t("list_of_partcipating_page_text12")}</span>
          <span>{t("list_of_partcipating_page_text13")}</span>
          <span>{t("list_of_partcipating_page_text14")}</span>
          <span>{t("list_of_partcipating_page_text15")}</span>
          <span>{t("list_of_partcipating_page_text16")}</span>
          <span>{t("list_of_partcipating_page_text17")}</span>
          <span>{t("list_of_partcipating_page_text18")}</span>
          <span>{t("list_of_partcipating_page_text19")}</span>
          <span>{t("list_of_partcipating_page_text20")}</span>
          <span>{t("list_of_partcipating_page_text21")}</span>
          <span>{t("list_of_partcipating_page_text22")}</span>
          <span>{t("list_of_partcipating_page_text23")}</span>
          <span>{t("list_of_partcipating_page_text24")}</span>
          <span>{t("list_of_partcipating_page_text25")}</span>
          <span>{t("list_of_partcipating_page_text26")}</span>
          <span>{t("list_of_partcipating_page_text27")}</span>
          <span>{t("list_of_partcipating_page_text28")}</span>
          <span>{t("list_of_partcipating_page_text29")}</span>
          <span>{t("list_of_partcipating_page_text30")}</span>
          <span>{t("list_of_partcipating_page_text31")}</span>
          <span>{t("list_of_partcipating_page_text32")}</span>
          <span>{t("list_of_partcipating_page_text33")}</span>
          <span>{t("list_of_partcipating_page_text34")}</span>
          <span>{t("list_of_partcipating_page_text35")}</span>
          <span>{t("list_of_partcipating_page_text36")}</span>
          <span>{t("list_of_partcipating_page_text37")}</span>
          <span>{t("list_of_partcipating_page_text38")}</span>
          <span>{t("list_of_partcipating_page_text39")}</span>
          <span>{t("list_of_partcipating_page_text40")}</span>
          <span>{t("list_of_partcipating_page_text41")}</span>
          <span>{t("list_of_partcipating_page_text42")}</span>
          <span>{t("list_of_partcipating_page_text43")}</span>
          <span>{t("list_of_partcipating_page_text44")}</span>
          <span>{t("list_of_partcipating_page_text45")}</span>
          <span>{t("list_of_partcipating_page_text46")}</span>
          <span>{t("list_of_partcipating_page_text47")}</span>
          <span>{t("list_of_partcipating_page_text48")}</span>
          <span>{t("list_of_partcipating_page_text49")}</span>
          <span>{t("list_of_partcipating_page_text50")}</span>
          <span>{t("list_of_partcipating_page_text51")}</span>
          <span>{t("list_of_partcipating_page_text52")}</span>
          <span>{t("list_of_partcipating_page_text53")}</span>
          <span>{t("list_of_partcipating_page_text54")}</span>
          <span>{t("list_of_partcipating_page_text55")}</span>
          <span>{t("list_of_partcipating_page_text56")}</span>
          <span>{t("list_of_partcipating_page_text57")}</span>
          <span>{t("list_of_partcipating_page_text58")}</span>
          <span>{t("list_of_partcipating_page_text59")}</span>
          <span>{t("list_of_partcipating_page_text60")}</span>
          <span>{t("list_of_partcipating_page_text61")}</span>
          <span>{t("list_of_partcipating_page_text62")}</span>
          <span>{t("list_of_partcipating_page_text63")}</span>
          <span>{t("list_of_partcipating_page_text64")}</span>
          <span>{t("list_of_partcipating_page_text65")}</span>
          <span>{t("list_of_partcipating_page_text66")}</span>
          <span>{t("list_of_partcipating_page_text67")}</span>
          <span>{t("list_of_partcipating_page_text68")}</span>
          <span>{t("list_of_partcipating_page_text69")}</span>
          <span>{t("list_of_partcipating_page_text70")}</span>
          <span>{t("list_of_partcipating_page_text71")}</span>
          <span>{t("list_of_partcipating_page_text72")}</span>
          <span>{t("list_of_partcipating_page_text73")}</span>
          <span>{t("list_of_partcipating_page_text74")}</span>
          <span>{t("list_of_partcipating_page_text75")}</span>
          <span>{t("list_of_partcipating_page_text76")}</span>
          <span>{t("list_of_partcipating_page_text77")}</span>
          <span>{t("list_of_partcipating_page_text78")}</span>
          <span>{t("list_of_partcipating_page_text79")}</span>
          <span>{t("list_of_partcipating_page_text80")}</span>
          <span>{t("list_of_partcipating_page_text81")}</span>
          <span>{t("list_of_partcipating_page_text82")}</span>
          <span>{t("list_of_partcipating_page_text83")}</span>
          <span>{t("list_of_partcipating_page_text84")}</span>
          <span>{t("list_of_partcipating_page_text85")}</span>
          <span>{t("list_of_partcipating_page_text86")}</span>
          <span>{t("list_of_partcipating_page_text87")}</span>
          <span>{t("list_of_partcipating_page_text88")}</span>
          <span>{t("list_of_partcipating_page_text89")}</span>
          <span>{t("list_of_partcipating_page_text90")}</span>
          <span>{t("list_of_partcipating_page_text91")}</span>
          <span>{t("list_of_partcipating_page_text92")}</span>
          <span>{t("list_of_partcipating_page_text93")}</span>
          <span>{t("list_of_partcipating_page_text94")}</span>
          <span>{t("list_of_partcipating_page_text95")}</span>
          <span>{t("list_of_partcipating_page_text96")}</span>
          <span>{t("list_of_partcipating_page_text97")}</span>
          <span>{t("list_of_partcipating_page_text98")}</span>
          <span>{t("list_of_partcipating_page_text99")}</span>
          <span>{t("list_of_partcipating_page_text100")}</span>
          <span>{t("list_of_partcipating_page_text101")}</span>
          <span>{t("list_of_partcipating_page_text102")}</span>
          <span>{t("list_of_partcipating_page_text103")}</span>
          <span>{t("list_of_partcipating_page_text104")}</span>
          <span>{t("list_of_partcipating_page_text105")}</span>
          <span>{t("list_of_partcipating_page_text106")}</span>
          <span>{t("list_of_partcipating_page_text107")}</span>
          <span>{t("list_of_partcipating_page_text108")}</span>
          <span>{t("list_of_partcipating_page_text109")}</span>
          <span>{t("list_of_partcipating_page_text110")}</span>
          <span>{t("list_of_partcipating_page_text111")}</span>
          <span>{t("list_of_partcipating_page_text112")}</span>
          <span>{t("list_of_partcipating_page_text113")}</span>
          <span>{t("list_of_partcipating_page_text114")}</span>
          <span>{t("list_of_partcipating_page_text115")}</span>
          <span>{t("list_of_partcipating_page_text116")}</span>
          <span>{t("list_of_partcipating_page_text117")}</span>
          <span>{t("list_of_partcipating_page_text118")}</span>
          <span>{t("list_of_partcipating_page_text119")}</span>
          <span>{t("list_of_partcipating_page_text120")}</span>
          <span>{t("list_of_partcipating_page_text121")}</span>
          <span>{t("list_of_partcipating_page_text122")}</span>
          <span>{t("list_of_partcipating_page_text123")}</span>
          <span>{t("list_of_partcipating_page_text124")}</span>
          <span>{t("list_of_partcipating_page_text125")}</span>
          <span>{t("list_of_partcipating_page_text126")}</span>
          <span>{t("list_of_partcipating_page_text127")}</span>
          <span>{t("list_of_partcipating_page_text128")}</span>
          <span>{t("list_of_partcipating_page_text129")}</span>
          <span>{t("list_of_partcipating_page_text130")}</span>
          <span>{t("list_of_partcipating_page_text131")}</span>
        </div> */}
      </main>
      <div className="temporary">
        <img src={BottomLogoImg} alt="" />
      </div>

      <Footer />
    </>
  );
};

export default ListofParticipatingInstitutionsPage;
